import { Text, View } from "react-native";
import { COLORS } from "../../lib/brand";

export function StatCard({
  label,
  value,
  delta,
  theme = "light",
}: {
  label: string;
  value: string | number;
  delta?: { value: string; direction: "up" | "down" };
  theme?: "light" | "dark";
}) {
  const box = theme === "dark" ? "bg-off-black border-white/10" : "bg-white border-sand-dark shadow-card-light";
  const labelCls = theme === "dark" ? "text-white/55" : "text-text/60";
  const valueColor = theme === "dark" ? COLORS.LINEN.hex : COLORS.FOREST.hex;
  return (
    <View className={`rounded-card border p-4 ${box}`}>
      <Text className={`text-[11px] ${labelCls}`} style={{ fontFamily: "DMSans_500Medium" }}>
        {label}
      </Text>
      <Text
        className="mt-1.5"
        style={{
          fontSize: 34,
          lineHeight: 36,
          fontFamily: "CormorantGaramond_400Regular",
          color: valueColor,
        }}
      >
        {value}
      </Text>
      {delta ? (
        <Text
          className={`mt-1 text-[10px] font-semibold ${delta.direction === "up" ? "text-success" : "text-amber"}`}
          style={{ fontFamily: "DMSans_600SemiBold" }}
        >
          {delta.value}
        </Text>
      ) : null}
    </View>
  );
}
